import { render, staticRenderFns } from "./ManageUsersTableSection.vue?vue&type=template&id=1aa98bac&scoped=true"
import script from "./ManageUsersTableSection.vue?vue&type=script&lang=js"
export * from "./ManageUsersTableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa98bac",
  null
  
)

export default component.exports